import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
// Import of the module

import { ExternalLink } from "@/components/ExternalLink";
import { formatNumber, parseDate } from "@/lib/utils";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table

export type Transaction = {
  id: number;
  time_serie_file_id?: number;
  time_serie_file_file_name?: string;

  date: string;
  portfolio: string;
  strategy: string;
  category?: number;
  description?: string;
  quantity?: number;
  market_value_ptf_ccy?: number;
  market_value_local_ccy?: number;
  transfer_issuer?: string;
  transfer_beneficiary?: string;
};

// Definition of the columns

export const transactions_columns: ColumnDef<Transaction>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "time_serie_file_file_name",
    header: "Time Series File",
    cell: ({ row }) => {
      const fileName = row.getValue("time_serie_file_file_name");
      const fileId = row.original.time_serie_file_id;
      if (fileName && fileId) {
        return (
          <ExternalLink
            href={toWorkspacePath(
              `/admin/legacy-quantilia/time_serie_files/${fileId}`,
            )}
            className="text-xs"
            underline="hover"
          >
            {fileName}
          </ExternalLink>
        );
      }
      return null;
    },
  },
  {
    accessorKey: "date",
    header: "Date",
    cell: ({ row }) => parseDate(row.getValue("date")),
  },
  {
    accessorKey: "portfolio",
    header: "Portfolio",
  },
  {
    accessorKey: "strategy",
    header: "Strategy",
  },
  {
    accessorKey: "category",
    header: "Category",
    cell: ({ row }) => {
      const value = row.getValue("category");
      return value !== null && value !== undefined ? value : "";
    },
  },
  {
    accessorKey: "description",
    header: "Description",
  },
  {
    accessorKey: "quantity",
    header: () => <div className="text-right">Quantity</div>,
    cell: ({ row }) => (
      <div className="text-right">{formatNumber(row.getValue("quantity"))}</div>
    ),
  },
  {
    accessorKey: "market_value_ptf_ccy",
    header: () => (
      <div className="text-right">Market Value (Portfolio Currency)</div>
    ),
    cell: ({ row }) => (
      <div className="text-right">
        {formatNumber(row.getValue("market_value_ptf_ccy"))}
      </div>
    ),
  },
  {
    accessorKey: "market_value_local_ccy",
    header: () => (
      <div className="text-right">Market Value (Local Currency)</div>
    ),
    cell: ({ row }) => (
      <div className="text-right">
        {formatNumber(row.getValue("market_value_local_ccy"))}
      </div>
    ),
  },
  {
    accessorKey: "transfer_issuer",
    header: "Transfer Issuer",
  },
  {
    accessorKey: "transfer_beneficiary",
    header: "Transfer Beneficiary",
  },
];
